module.exports = __webpack_public_path__ + "assets1775130923925/img/logo1.bcf77f3c.png";